import { render, staticRenderFns } from "./PerformanceModal.vue?vue&type=template&id=bdf5fe32&scoped=true"
import script from "./PerformanceModal.vue?vue&type=script&lang=js"
export * from "./PerformanceModal.vue?vue&type=script&lang=js"
import style1 from "./PerformanceModal.vue?vue&type=style&index=1&id=bdf5fe32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf5fe32",
  null
  
)

export default component.exports